import { render, staticRenderFns } from "./EventFieldForm.vue?vue&type=template&id=7fed61d2"
import script from "./EventFieldForm.vue?vue&type=script&lang=js"
export * from "./EventFieldForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports